import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 12.023a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0m17.25 0a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0m-8.625 0a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0"
    }, null, -1)
  ]));
}
const interfaceDotsHorizontal = { render };
export {
  interfaceDotsHorizontal as default,
  render
};
//# sourceMappingURL=interface-dots-horizontal.svg.js.map
